import queryString from 'query-string'
import {rawAPI} from './raw'

// raw.jsのラッパー
// APIにリクエスト数制限をかける
class API extends rawAPI {
  constructor() {
    super()
    this.counter = {
      variableRegister: {
        count: 0,
        limitPerHour: 30
      },
      sendData: {
        count: 0,
        limitPerHour: 3600
      }
    }

    setInterval(() => {
      this.counter.variableRegister.count = 0
      this.counter.sendData.count = 0
    }, 60*60*1000)
  }

  variableRegister(name, token) {
    if (this.counter.variableRegister.count > this.counter.variableRegister.limitPerHour) {
      return Promise.reject("新しい変数を作りすぎです。しばらく待ってから試してください。")
    }
    this.counter.variableRegister.count++;
    return this.getGroup(token)
    .then(grp => {
      return super.variableRegister(name, grp.GroupID, token)
    })
  }

  sendData(value, token) { // value type is not implemented.
    if (this.counter.sendData.count > this.counter.sendData.limitPerHour) {
      return Promise.reject("データを送りすぎです。しばらく待ってから試してください。")
    }
    this.counter.sendData.count++;
    return super.sendData(value, "string", token)
  }
}

class _AuthAPI {
  constructor() {
    this.endpoint = "https://auth.tfabconnect.com"
  }

  getToken(redirect_uri, code) {
    const query = {
      'grant_type': 'authorization_code',
      'client_id': '1nsderidh969374vl5mvitinhs',
      'scope': 'phone+email+openid+profile',
      'redirect_uri': redirect_uri,
      'code': code,
    }
    return fetch(`${this.endpoint}/oauth2/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: queryString.stringify(query, {encode: false})
    }).then(res => {
      if (!res.ok)
        return Promise.reject('cannot get token.')
      return res.json()
    })
  }
}

// Singleton Pattern
export default new API
export const AuthAPI = new _AuthAPI()
